import React, { PropTypes } from 'react';

import { find } from 'lodash';

import { NitroAccordion, NitroCheckbox } from 'nitro-components';

import styled from 'styled-components';

const ExtraCheckbox = styled.div`
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${props => props.theme.color.border};
  &:last-child {
    border-bottom: none;
  }
`;

const Extras = ({ options, setEstimatedCost, selectedExtras }) => {
  let includedExtras = options.map((option, index) => {
    if (!option.Standard)
      return (
        <ExtraCheckbox key={index}>
          <NitroCheckbox
            variant="secondary"
            checked={Boolean(find(selectedExtras, e => e.code === option.Code))}
            label={option.Description}
            action={(event, isInputChecked, price, code, description) =>
              setEstimatedCost(event, isInputChecked, option.Price, option.Code, option.Description)}
          />
        </ExtraCheckbox>
      );
    else {
      return null;
    }
  });

  return <NitroAccordion title="Extras" details={includedExtras} active />;
};

Extras.propTypes = {
  options: PropTypes.array.isRequired,
  setEstimatedCost: PropTypes.func,
  selectedExtras: PropTypes.array
};

export default Extras;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/Extras.js